export const soledad = {
	nombre: "Soledad",
	dia: "Sábado Santo",
	nombrecompleto:
		"Venerable y Real Cofradía de Nuestra Señora de la Soledad y Santo Entierro de Nuestro Señor Jesucristo",
	sede: "Parroquia de Santa Cruz",
	pasos: 2,
	distancia: [1080, 1710],
	penitentes: 170,
	cargadores: 64,
	web:
		"http://www.diariodecadiz.es/semana_santa/Santo-Entierro_0_1229577740.html",

	ida: [
		{ lng: -6.2946135, lat: 36.5284996 },
		{ lng: -6.2946591, lat: 36.5285277 },
		{ lng: -6.2945116, lat: 36.5287604 },
		{ lng: -6.2942031, lat: 36.5288337 },
		{ lng: -6.2941092, lat: 36.5291743 },
		{ lng: -6.2938692, lat: 36.5291484 },
		{ lng: -6.2938035, lat: 36.529199 },
		{ lng: -6.2932824, lat: 36.5291371 },
		{ lng: -6.2932355, lat: 36.5293963 },
		{ lng: -6.2933844, lat: 36.529406 },
		{ lng: -6.2933327, lat: 36.5297222 },
		{ lng: -6.2936385, lat: 36.5297018 },
		{ lng: -6.2939128, lat: 36.5296931 },
		{ lng: -6.2945297, lat: 36.5296306 },
		{ lng: -6.2945813, lat: 36.5296425 },
		{ lng: -6.2944438, lat: 36.5302293 },
		{ lng: -6.2943432, lat: 36.5305574 },
		{ lng: -6.2941749, lat: 36.5305623 },
		{ lng: -6.2939101, lat: 36.5306124 },
		{ lng: -6.2935674, lat: 36.5307131 },
		{ lng: -6.2933817, lat: 36.5308058 },
		{ lng: -6.2931577, lat: 36.5309324 },
		{ lng: -6.2929519, lat: 36.5310612 },
		{ lng: -6.2921834, lat: 36.5302799 },
		{ lng: -6.2928003, lat: 36.5297713 },
		{ lng: -6.2933394, lat: 36.5297476 },
		{ lng: -6.2936425, lat: 36.5297217 },
		{ lng: -6.2939107, lat: 36.5297195 },
		{ lng: -6.2945196, lat: 36.529657 },
		{ lng: -6.2946242, lat: 36.5295622 },
		{ lng: -6.2950748, lat: 36.5296204 },
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 },

		{ lng: -6.2956917, lat: 36.5291074 },
		{ lng: -6.2954128, lat: 36.5297583 },
		{ lng: -6.2956703, lat: 36.5299502 },
		{ lng: -6.2952733, lat: 36.5303532 },
		{ lng: -6.2950721, lat: 36.5307024 },
		{ lng: -6.2950212, lat: 36.5308338 },
		{ lng: -6.2949327, lat: 36.5308403 },
		{ lng: -6.29493, lat: 36.5314567 },
		{ lng: -6.2964803, lat: 36.53178 },
		{ lng: -6.2964213, lat: 36.5318683 },
		{ lng: -6.2965661, lat: 36.5321334 },
		{ lng: -6.2967888, lat: 36.5325515 },
		{ lng: -6.2964186, lat: 36.5329406 },
		{ lng: -6.2962657, lat: 36.5332455 },
		{ lng: -6.2963274, lat: 36.533294 },
		{ lng: -6.2962697, lat: 36.5339362 },
		{ lng: -6.2960109, lat: 36.5339702 },
		{ lng: -6.295457, lat: 36.5340171 },
		{ lng: -6.2929358, lat: 36.5310892 },
		{ lng: -6.2921445, lat: 36.5302832 },
		{ lng: -6.2927882, lat: 36.5297438 },
		{ lng: -6.2933039, lat: 36.5297227 },
		{ lng: -6.2933488, lat: 36.5294267 },
		{ lng: -6.2932019, lat: 36.5294164 },
		{ lng: -6.2932589, lat: 36.5291161 },
		{ lng: -6.2937907, lat: 36.5291751 },
		{ lng: -6.2938504, lat: 36.5291263 },
		{ lng: -6.2940951, lat: 36.5291508 },
		{ lng: -6.2941799, lat: 36.5288031 },
		{ lng: -6.2944745, lat: 36.5287392 },
		{ lng: -6.2946177, lat: 36.5285413 },
		{ lng: -6.294592, lat: 36.5285287 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-31T15:00",
			latlng: [36.52851, -6.29459]
		},
		{
			name: "Nueva",
			hora: "2018-03-31T16:45",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-31T17:45",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-31T18:45",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-31T19:10",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-31T19:20",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Jesús de Medinaceli",
			"Plaza de Fray Félix",
			"Obispo José Mª. Rances",
			"Plaza San Martin",
			"Posadilla",
			"San Antonio Abad",
			"Fabio Rufino",
			"Pomponio Mela",
			"Pelota",
			"Cobos",
			"Cristóbal Colón",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañes", "Palillero"],
		["Novena", "Valverde"],
		[
			"Beato Diego de Cadiz",
			"San Francisco",
			"Plaza San Agustín",
			"San Francisco",
			"Nueva",
			"Plaza San Juan de Dios",
			"Pomponio Mela",
			"Fabio Rufino",
			"San Antonio Abad",
			"Posadilla",
			"Plaza San Martin",
			"Obispo José Mª Rances",
			"Plaza de Fray Félix",
			"Jesús de Medinaceli"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/soledad.js